export class Suggestion {
	// eslint-disable-line no-unused-vars

	/**
	 * Initialise the suggestion.
	 *
	 * @param {string} title
	 * @param {string} type
	 * @param {string} paramName
	 * @param {string} ID
	 * @param {boolean} isExactMatch
	 * @param {string} position
	 * @return void
	 */

	constructor(title, type, paramName, ID, isExactMatch, position) {
		this.title = title;
		this.type = type;
		this.paramName = paramName;
		this.id = ID;
		this.isExactMatch = isExactMatch;
		this.position = position;
	}

	/**
	 * Render an individual suggestion.
	 *
	 * @returns {HTMLElement}
	 */

	render() {
		const li = document.createElement('li');
		li.innerText = this.title;
		li.className = 'Suggestion Link';
		li.dataset.position = this.position;
		li.dataset.paramValue = this.id;
		li.dataset.paramName = this.paramName;
		return li;
	}
}
